import { NavLink } from "react-router";
import { useReaction } from "../avatar";
import { NavIcon } from "./NavIcon";
import { NAV_ITEMS } from "./nav-items";

type Props = { onNavigate?: () => void };

export function NavLinks({ onNavigate }: Props) {
  return (
    <ul className="nav-links">
      {NAV_ITEMS.map((item) => (
        <li key={item.to}>
          <NavLinkItem item={item} {...(onNavigate ? { onNavigate } : {})} />
        </li>
      ))}
    </ul>
  );
}

function NavLinkItem({
  item,
  onNavigate,
}: {
  item: (typeof NAV_ITEMS)[number];
  onNavigate?: () => void;
}) {
  const reaction = useReaction(item.reaction);
  return (
    <NavLink
      to={item.to}
      className="nav-links__link"
      {...reaction}
      {...(onNavigate ? { onClick: onNavigate } : {})}
    >
      <NavIcon name={item.icon} />
      <span className="nav-links__label">{item.label}</span>
    </NavLink>
  );
}
